export const queryStringCalc = (reportConfig, criteria, token, { sencondReport, devSetting }) => {
  let departments;
  if (reportConfig.filters.showDepartments && criteria.departments.length > 0) {
    departments = criteria.departments.join(',');
  }
  departments = departments ? `departments=${departments}` : '';

  let trustTypes;
  if (reportConfig.filters.showTrustTypes && criteria.trustTypes.length > 0) {
    trustTypes = criteria.trustTypes.join(',');
  }
  trustTypes = trustTypes ? `trustTypes=${trustTypes}` : '';

  let officer;
  if (reportConfig.filters.showOfficers
    && (criteria.officer || '').length > 0) {
    officer = criteria.officer;
  }
  officer = officer ? `officer=${officer}` : '';

  let format;
  if (reportConfig.filters.showFileFormat
    && (criteria.format || '').length > 0) {
    format = criteria.format;
  }
  format = format ? `format=${format}` : '';

  let wkst;
  if (reportConfig.filters.showWkst && criteria.wkst.length > 0) {
    wkst = criteria.wkst.join(',');
  }
  wkst = wkst ? `wkst=${wkst}` : '';

  // vuetify defaults to YYYY-MM-DD format
  let fromDate;
  if (reportConfig.filters.showFromToDates && criteria.fromDate) {
    fromDate = criteria.fromDate;
  }
  fromDate = fromDate ? `fromDate=${fromDate}` : '';

  let toDate;
  if ((reportConfig.filters.showFromToDates || reportConfig.filters.showToDates)
     && criteria.toDate) {
    toDate = criteria.toDate;
  }
  toDate = toDate ? `toDate=${toDate}` : '';

  let isEftCode;
  if (reportConfig.filters.isEftCode) {
    isEftCode = criteria.isEftCode;
  }
  isEftCode = isEftCode !== null ? `isEftCode=${isEftCode}` : '';
  let fromFinalizedDate;
  if (reportConfig.filters.showFromToFinalizedDates && criteria.fromFinalizedDate) {
    fromFinalizedDate = criteria.fromFinalizedDate;
  }
  fromFinalizedDate = fromFinalizedDate ? `fromFinalizedDate=${fromFinalizedDate}` : '';

  let toFinalizedDate;
  if (reportConfig.filters.showFromToFinalizedDates && criteria.toFinalizedDate) {
    toFinalizedDate = criteria.toFinalizedDate;
  }
  toFinalizedDate = toFinalizedDate ? `toFinalizedDate=${toFinalizedDate}` : '';

  let fy;
  if (reportConfig.filters.showFiscalYears && criteria.fy) {
    fy = criteria.fy;
  }
  fy = fy ? `fy=${fy}` : '';

  // a calendar year (not a fiscal year), for reports that only take a year
  let year;
  if (reportConfig.filters.showYear && criteria.year) {
    year = criteria.year;
  }
  year = year ? `year=${year}` : '';

  const isSingleDeptSelected = criteria.departments.length === 1;
  let fromVoucher;
  if (reportConfig.filters.showFromToVoucher && isSingleDeptSelected && criteria.fromVoucher) {
    fromVoucher = criteria.fromVoucher;
  }
  fromVoucher = fromVoucher ? `fromVoucher=${fromVoucher}` : '';

  let toVoucher;
  if (reportConfig.filters.showFromToVoucher && isSingleDeptSelected && criteria.toVoucher) {
    toVoucher = criteria.toVoucher;
  }
  toVoucher = toVoucher ? `toVoucher=${toVoucher}` : '';

  let isCancelledByStatute;
  if (reportConfig.filters.showCancelledByStatute) {
    isCancelledByStatute = `isCancelledByStatute=${criteria.isCancelledByStatute}`;
  }
  let printFullDesc;
  if (reportConfig.filters.showPrintFullRemarks) {
    printFullDesc = `printFullDesc=${criteria.printFullDesc}`;
  }
  let logicalTypes;
  if (reportConfig.filters.showTransTypes && criteria.logicalTypes.length > 0) {
    logicalTypes = criteria.logicalTypes.join(',');
  }
  logicalTypes = logicalTypes ? `logicalTypes=${logicalTypes}` : '';

  let reportType;
  if (reportConfig.reportType && reportConfig.reportType.length > 0) {
    if (sencondReport) {
      [, reportType] = reportConfig.reportType;
    } else {
      [reportType] = reportConfig.reportType;
    }
    reportType = `reportType=${reportType}`;
  }

  /* For testcafe */
  let isTestCafe;
  if (devSetting && devSetting.isTestEnvironment) {
    isTestCafe = `isTestCafe=${1}`;
  }

  let isShowAllOfficersSinglePage;
  if (reportConfig.filters && reportConfig.filters.showPrintAllOfficerSinglePage) {
    isShowAllOfficersSinglePage = criteria.isShowAllOfficersSinglePage ? `isShowAllOfficersSinglePage=${criteria.isShowAllOfficersSinglePage}` : '';
  }

  const params = [
    logicalTypes,
    wkst,
    isCancelledByStatute,
    printFullDesc,
    fromDate,
    toDate,
    format,
    fromFinalizedDate,
    toFinalizedDate,
    fy,
    year,
    officer,
    departments,
    trustTypes,
    token,
    reportType,
    isTestCafe,
    isEftCode,
    isShowAllOfficersSinglePage,
    fromVoucher,
    toVoucher,
  ];

  const paramFilter = (p) => p !== undefined && p !== '';
  let queryString = params.filter(paramFilter).join('&');
  queryString = (queryString.length > 0) ? `?${queryString}` : '';

  return queryString;
};

export const isValidReportYear = (year) => /^\d{4}$/.test(`${year}`);

export const validateQueryString = (to, queryString) => {
  let hasErrors = false;
  const errors = [];
  const params = queryString.split('&');
  switch (to) {
    case 'sai140': {
      const officerParam = params.filter((param) => param.indexOf('officer') !== -1);
      if (officerParam.length === 0 || officerParam[0] === 'officer=') {
        hasErrors = true;
        errors.push('Select an officer');
      }
      break;
    }
    case 'payments/creditCardSummary': {
      const pairs = params.map((param) => param.replace(/^\?/, ''));
      const isPrintOSOnly = pairs.includes('isPrintOSOnly=true');
      const asOfDate = (pairs.find((param) => param.indexOf('asOfDate=') === 0) || '').slice('asOfDate='.length);
      if (isPrintOSOnly && !asOfDate) {
        hasErrors = true;
        errors.push('Enter an As Of Date when printing outstanding only');
      }
      break;
    }
    default:
  }
  return {
    hasErrors,
    errors,
  };
};

export const reportList = () => {
  const list = [
    {
      description: 'Daily Edit',
      config: {
        route: 'dailyedit',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          showTransTypes: true,
          showFiscalYears: true,
        },
      },
    },
    {
      description: 'Deposit Register',
      config: {
        route: 'depositregister',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          showFiscalYears: true,
        },
      },
    },
    {
      description: 'Deposit Register By Workstation',
      config: {
        route: 'od/depositregister-by-wkst',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          showFiscalYears: true,
          showWkst: true,
        },
      },
    },
    {
      description: 'Voucher Register',
      config: {
        route: 'voucherregister',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          showFiscalYears: true,
        },
      },
    },
    {
      description: 'Cancelled Voucher Register',
      config: {
        route: 'od/cancelled-vouchers',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          showFiscalYears: true,
          showCancelledByStatute: true,
        },
      },
    },
    {
      description: 'Outstanding Vouchers',
      config: {
        route: 'outstandingvouchers',
        filters: {
          showDepartments: true,
          showToDates: true,
        },
      },
    },
    {
      description: 'Outstanding Vouchers By Department',
      config: {
        route: 'outstandingvouchersbydept',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          showFileFormat: true,
        },
      },
    },
    {
      description: 'Outstanding CC & EFT Deposits',
      config: {
        route: 'outstandingccdeposits',
        filters: {
          showDepartments: true,
          showFromToDates: true,
        },
      },
    },
    {
      description: 'Cancellation Letters',
      config: {
        route: 'cancelletters',
        filters: {
          showDepartments: true,
          showFromToFinalizedDates: true,
          showFiscalYears: true,
        },
      },
    },
    {
      description: 'FY Department Balances',
      config: {
        route: 'deptbalances',
        filters: {
          showDepartments: true,
          showFiscalYears: true,
        },
      },
    },
    {
      description: 'Department Control Balances',
      config: {
        route: 'deptcontrols',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          showFileFormat: true,
          showFiscalYears: true,
        },
      },
    },
    {
      description: 'Vouchers Redeemed by Dept',
      config: {
        route: 'vouchredeembydept',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          isEftCode: true,
        },
      },
    },
    {
      description: 'Vouchers Redeemed (by Reg and FY)',
      config: {
        route: 'vouchredeemed',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          isEftCode: true,
        },
      },
    },
    {
      description: 'Monthly Officers (SAI 140)',
      config: {
        route: 'sai140',
        filters: {
          showOfficers: true,
          showFromToDates: true,
          showFiscalYears: true,
          showPrintAllOfficerSinglePage: true,
        },
      },
    },
    {
      description: 'General Ledger',
      config: {
        route: 'generalledger',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          showFiscalYears: true,
        },
      },
    },
    {
      description: 'Bank Deposit',
      config: {
        route: 'bankdeposit',
        filters: {
          showDepartments: true,
          showFromToDates: true,
        },
        reportType: ['detailed', 'summary'],
      },
    },
    {
      description: 'Trust Receipts by Date',
      config: {
        route: 'trustreceiptreport',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          showTrustTypes: true,
        },
      },
    },
    {
      description: 'Prepaid Mobile Home Report',
      config: {
        route: 'od/prepaid-mobile-home',
        filters: {
          showYear: true,
        },
      },
    },
    {
      description: 'Corrections Register',
      config: {
        route: 'correctionregister',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          showFiscalYears: true,
          showPrintFullRemarks: true,
        },
      },
    },
    {
      description: 'Print Vouchers',
      config: {
        route: 'vouchercheck',
        filters: {
          showDepartments: true,
          showFromToDates: true,
          showFiscalYears: true,
          showFromToVoucher: true,
        },
      },
    },
  ];
  return list;
};

export default {
  reportList,
  queryStringCalc,
  validateQueryString,
  isValidReportYear,
};
